import React from "react";

export default function VKardLink({
  url = "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
  logo = "https://media.licdn.com/dms/image/v2/D4E0BAQETJ3lAsk4sKA/company-logo_200_200/company-logo_200_200/0/1716333982627/vkard_io_logo?e=2147483647&v=beta&t=0mcqCmpMvHUPuoWJ5UFSid1as0YzDhH2ital1cterIg",
  label = "Ma VKard",
}) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Ouvrir ma carte de visite VKard"
      className="inline-flex items-center gap-2 rounded-xl ring-1 ring-slate-300 bg-white/70 dark:bg-slate-900/50
                 px-3 py-2 text-sm font-semibold text-slate-700 dark:text-slate-200
                 hover:ring-sky-300 hover:text-sky-800 dark:hover:text-sky-200
                 transition transform hover:scale-[1.03] focus:outline-none focus:ring-2 focus:ring-violet-400"
    >
      <img
        src={logo}
        alt="VKard"
        width={50}
        height={50}
        className="h-[50px] w-[50px] rounded-md object-contain"
        loading="lazy"
      />
      <span>{label}</span>
    </a>
  );
}
